module.exports = __webpack_public_path__ + "img/7f792f0.svg";